<div class="account-style">
  <div class="account">
    <h2 class="floatLeft">Account</h2>
    <div [@fadeInOut] *ngIf="isProfileActived" class="content-container">
      <app-contact-info>
        <app-notification-loading></app-notification-loading>
      </app-contact-info>
    </div>
  </div>
</div>
